import { useCallback } from 'react';
import { isSome } from 'fp-ts/Option';
import { dispatchDashboardEdit, ModalDiscardChangesState, useDashboardEdit } from 'adapter/in/dashboards/context/EditDashboard';

const useDiscardChangesModal = (): {
    modalDiscardChanges: ModalDiscardChangesState;
    onModalAbortChanges: () => void;
    onModalCancel: () => void;
    onModalSaveAndProceed?: () => void;
} => {
    const { modalDiscardChanges, dashboard } = useDashboardEdit();
    const { setModalDiscardChanges } = dispatchDashboardEdit();
    const handleOnModalCancel = useCallback(() => setModalDiscardChanges(false), []);

    const handleOnModalAbortChanges = useCallback(() => {
        if (isSome(dashboard) && modalDiscardChanges.viewCleanupAction) {
            modalDiscardChanges.viewCleanupAction();
        }
    }, [modalDiscardChanges, dashboard]);

    const handleOnModalSaveAndProceed = useCallback(() => {
        if (isSome(dashboard) && modalDiscardChanges.saveAndProceedAction && modalDiscardChanges.viewCleanupAction) {
            modalDiscardChanges.saveAndProceedAction();
            modalDiscardChanges.viewCleanupAction();
        }
    }, [modalDiscardChanges, dashboard]);

    return {
        modalDiscardChanges,
        onModalAbortChanges: handleOnModalAbortChanges,
        onModalCancel: handleOnModalCancel,
        onModalSaveAndProceed: modalDiscardChanges.saveAndProceedAction ? handleOnModalSaveAndProceed : undefined,
    };
};

export default useDiscardChangesModal;
